// Standalone entry point — loaded by index.html in dev/preview mode.
// In hosted mode, the host loads ./AppMount directly via Module Federation.
import { normalizeHashCallbackUrl } from "./shared/auth/callbackUrl";

normalizeHashCallbackUrl();

void import("./bootstrap").then(({ mount }) => {
  const devEl = document.getElementById("app");
  if (devEl) {
    void import("./shared/styles/global.css");
    void mount({ $element: devEl, standAlone: true });
  }
});
